/* 路由配置全写这里 */
import Vue from 'vue'
import VueRouter from 'vue-router'

/* 开启debug模式 */
// Vue.config.debug = true
Vue.use(VueRouter);

/* import Family from '../pages/familytable.1.vue'
import FamilyID from '../pages/family_id.vue'

import Classes from '../pages/classes.vue'
import PayClasses from '../pages/pay_classes.vue'
import Teachers from '../pages/teachers.vue'
 */
/* import Payment from '../pages/payment.vue'
import Volunteers from '../pages/volunteers.vue'

import Login from '../components/Login.vue'; */

import Attendance from '../pages/attendance.vue'
//import Report_Attendance from '../pages/report_attend.vue'
import Teacher_Login from '../components/Teacher_Login.vue';

// import Index from '../pages/index.vue'
// import Student from '../pages/student.vue'

// this vue page cause all link to dissappear ????
 //import StudentID from '../pages/student_id.vue'
// import News from '../pages/news.vue'
//import secondcomponent from '../pages/otherPages.vue'
//import thirdcomponent from '../pages/otherPages2.vue'

//import auth from '../auth'


// Check the users auth status when the app starts
// auth.checkAuth();

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
   //   { path: '/adminlogin', component: Login },
      { path: '/teacherlogin', component: Teacher_Login },
    /* {
      path: '/family',
      component: Family
    },  
    {
     // path: '/family-id/:id',
      path: '/family-id/',
      name: 'withfamilyID',
      component: FamilyID
    },   */
   /*  {
      path: '/classes',
      component: Classes
    }, */
   {
      path: '/attendance',
      component: Attendance
    }, /*    {
      path: '/report_attendance',
      component: Report_Attendance
    }, */ /*    {
      path: '/payclasses',
      component: PayClasses
    },
    {
      path: '/payment',
      component: Payment
    },   
    {
      path: '/volunteers',
      component: Volunteers
    },
    {
      path: '/teachers',
      component: Teachers
    }, */
    /* {
      path: '/student',
      component: Student
    },
        {
      path: '/student-id/',
      name: 'withstudentID',
      component: StudentID
    } */
  /*   ,
      { path: '*', redirect: '/login' } */

    ,
    
   /*  {
      path: '/second',
      component: secondcomponent
    },
    {
      path: '/third',
      component: thirdcomponent
    } */
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js